export const TEST_ID = 'sliderField';
